/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Assume documentId is at end of url path.
 * This is true for Routerlicious' and Tinylicious' documentUrl and deltaStorageUrl.
 * Routerlicious and Tinylicious do not use documentId in storageUrl nor ordererUrl.
 * TODO: Ideally we would be able to regenerate the resolvedUrl, rather than patching the current one.
 */
export const replaceDocumentIdInPath = (urlPath, documentId) => urlPath.split("/").slice(0, -1).concat([documentId]).join("/");
export const getDiscoveredFluidResolvedUrl = (resolvedUrl, session) => {
    const discoveredOrdererUrl = new URL(session.ordererUrl);
    // TODO why are we non null asserting here?
    const deltaStorageUrl = new URL(resolvedUrl.endpoints.deltaStorageUrl);
    deltaStorageUrl.host = discoveredOrdererUrl.host;
    const discoveredStorageUrl = new URL(session.historianUrl);
    // TODO why are we non null asserting here?
    const storageUrl = new URL(resolvedUrl.endpoints.storageUrl);
    storageUrl.host = discoveredStorageUrl.host;
    const parsedUrl = new URL(resolvedUrl.url);
    const discoveredResolvedUrl = {
        endpoints: {
            deltaStorageUrl: deltaStorageUrl.toString(),
            ordererUrl: session.ordererUrl,
            deltaStreamUrl: session.deltaStreamUrl,
            storageUrl: storageUrl.toString(),
        },
        id: resolvedUrl.id,
        tokens: resolvedUrl.tokens,
        type: resolvedUrl.type,
        url: new URL(`https://${discoveredOrdererUrl.host}${parsedUrl.pathname}`).toString(),
    };
    return discoveredResolvedUrl;
};
//# sourceMappingURL=urlUtils.js.map